import request from '@/utils/request'
import api from '@/api'
import { arrayObjectSort } from '@/utils'

const state = () => ({})
const getters = {}

const mutations = {}

const actions = {
  GetPackagePageListByMarketingChannelId(context, params) {
    return request({
      url: api.GetPackagePageListByMarketingChannelId,
      method: 'GET',
      params,
    })
  },
  PackageReceive(context, params) {
    return request({
      url: api.PackageReceive,
      method: 'POST',
      data: params,
    })
  },
  PackageReceiveCoupon(context, params) {
    return request({
      url: api.PackageReceiveCoupon,
      method: 'POST',
      data: params,
    })
  },
  //使用优惠券生成服务计划订单
  PackageUseCoupon(context, params) {
    return request({
      url: api.PackageUseCoupon,
      method: 'POST',
      data: params,
    })
  },
  PackageGet(context, params) {
    return request({
      url: api.PackageGet,
      method: 'GET',
      params,
    })
  },
  PackageGetPackageDetailList(context, params) {
    return request({
      url: api.PackageGetPackageDetailList,
      method: 'GET',
      params,
    })
  },
  PackageGetPackageInfoBeforeReceive(context, params) {
    return request({
      url: api.PackageGetPackageInfoBeforeReceive,
      method: 'GET',
      params,
    })
  },
  GetPackageByDetailId(context, params) {
    return request({
      url: api.GetPackageByDetailId,
      method: 'GET',
      params,
    })
  },
  GetFormOrderCoupon(context, params) {
    return request({
      url: api.FormGetFormOrderCoupon,
      method: 'GET',
      params,
    })
  },
  FormGetAgreementWithSignatureInfo(context, params) {
    return request({
      url: api.FormGetAgreementWithSignatureInfo,
      method: 'GET',
      params,
    })
  },
  ReceiveWithCreatePaymentOrder(context, params) {
    return request({
      url: api.ReceiveWithCreatePaymentOrder,
      method: 'POST',
      data: params,
    })
  },
  PackageJsapiPayment(context, params) {
    return request({
      url: api.PackageJsapiPayment,
      method: 'POST',
      data: params,
    })
  },
  GetProductWorkflow(context, params) {
    return request({
      url: api.GetProductWorkflow,
      method: 'GET',
      params,
    })
  },
  FormSignAgreement(context, params) {
    return request({
      url: api.FormSignAgreement,
      method: 'POST',
      data: params,
    })
  },
  ProductAgreementGetAgreement(context, params) {
    return request({
      url: api.ProductAgreementGetAgreement,
      method: 'GET',
      params,
    })
  },
  GetAgreementInfo(context, params) {
    return request({
      url: api.GetAgreementInfo,
      method: 'GET',
      params,
    })
  },
  FormJsapiPayment(context, params) {
    return request({
      url: api.FormJsapiPayment,
      method: 'POST',
      data: params,
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
